var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _ellipse, _linearGradient5, _path4, _linearGradient6, _circle, _linearGradient7, _circle2, _linearGradient8, _path5, _linearGradient9, _circle3, _linearGradient0, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8DatabaseAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wOQouxenu~XFRQP1lFFAya",
    x1: 9,
    x2: 39,
    y1: 36,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#11408a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#103f8f"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#wOQouxenu~XFRQP1lFFAya)",
    d: "M39,29H9c0,0,0,8.657,0,9c0,2.761,6.716,5,15,5s15-2.239,15-5C39,37.657,39,29,39,29z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wOQouxenu~XFRQP1lFFAyb",
    x1: 9,
    x2: 39,
    y1: 26.5,
    y2: 26.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d59b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#195bbc"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#wOQouxenu~XFRQP1lFFAyb)",
    d: "M39,19H9c0,0,0,9.657,0,10c0,2.761,6.716,5,15,5s15-2.239,15-5C39,28.657,39,19,39,19z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wOQouxenu~XFRQP1lFFAyc",
    x1: 9,
    x2: 39,
    y1: 16.75,
    y2: 16.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3079d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#297cd2"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#wOQouxenu~XFRQP1lFFAyc)",
    d: "M39,9.5H9c0,0,0,9.157,0,9.5c0,2.761,6.716,5,15,5s15-2.239,15-5C39,18.657,39,9.5,39,9.5z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wOQouxenu~XFRQP1lFFAyd",
    x1: 9,
    x2: 39,
    y1: 9.5,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#42a3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42a4eb"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 9.5,
    fill: "url(#wOQouxenu~XFRQP1lFFAyd)",
    rx: 15,
    ry: 4.5
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wOQouxenu~XFRQP1lFFAye",
    x1: 31.189,
    x2: 45.426,
    y1: 31.169,
    y2: 45.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#889097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#848c94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#78828b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64717c"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#wOQouxenu~XFRQP1lFFAye)",
    d: "M47.715,35.647c-1.193,0.151-2.415-0.407-3.054-1.514c-0.639-1.106-0.512-2.444,0.216-3.401 c-1.129-1.072-2.505-1.884-4.038-2.338c-0.464,1.111-1.56,1.893-2.839,1.893s-2.375-0.781-2.839-1.893 c-1.533,0.453-2.909,1.266-4.038,2.338c0.727,0.957,0.854,2.295,0.216,3.401c-0.639,1.106-1.861,1.665-3.054,1.514 C28.105,36.396,28,37.175,28,37.979c0,0.805,0.105,1.583,0.285,2.332c1.193-0.151,2.415,0.407,3.054,1.514 c0.639,1.106,0.512,2.444-0.216,3.401c1.129,1.072,2.505,1.884,4.038,2.338c0.464-1.111,1.56-1.893,2.839-1.893 s2.375,0.781,2.839,1.893c1.533-0.453,2.909-1.266,4.038-2.338c-0.727-0.957-0.854-2.295-0.216-3.401 c0.639-1.106,1.861-1.665,3.054-1.514C47.895,39.562,48,38.784,48,37.979C48,37.175,47.895,36.396,47.715,35.647z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wOQouxenu~XFRQP1lFFAyf",
    x1: 41.751,
    x2: 34.198,
    y1: 41.731,
    y2: 34.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 37.979,
    r: 5.385,
    fill: "url(#wOQouxenu~XFRQP1lFFAyf)"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wOQouxenu~XFRQP1lFFAyg",
    x1: 34.933,
    x2: 40.313,
    y1: 34.912,
    y2: 40.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d61a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#0e5fa4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#135796"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16528c"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 37.979,
    r: 3.278,
    fill: "url(#wOQouxenu~XFRQP1lFFAyg)"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wOQouxenu~XFRQP1lFFAyh",
    x1: 31.189,
    x2: 45.426,
    y1: 31.21,
    y2: 45.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#889097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#848c94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#78828b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64717c"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#wOQouxenu~XFRQP1lFFAyh)",
    d: "M47.715,35.688c-1.193,0.151-2.415-0.407-3.054-1.514c-0.639-1.106-0.512-2.444,0.216-3.401 c-1.129-1.072-2.505-1.884-4.038-2.338c-0.464,1.111-1.56,1.893-2.839,1.893s-2.375-0.781-2.839-1.893 c-1.533,0.453-2.909,1.266-4.038,2.338c0.727,0.957,0.854,2.295,0.216,3.401c-0.639,1.106-1.861,1.665-3.054,1.514 C28.105,36.438,28,37.216,28,38.021c0,0.805,0.105,1.583,0.285,2.332c1.193-0.151,2.415,0.407,3.054,1.514 c0.639,1.106,0.512,2.444-0.216,3.401c1.129,1.072,2.505,1.884,4.038,2.338c0.464-1.111,1.56-1.893,2.839-1.893 s2.375,0.781,2.839,1.893c1.533-0.453,2.909-1.266,4.038-2.338c-0.727-0.957-0.854-2.295-0.216-3.401 c0.639-1.106,1.861-1.665,3.054-1.514C47.895,39.604,48,38.825,48,38.021C48,37.216,47.895,36.438,47.715,35.688z"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wOQouxenu~XFRQP1lFFAyi",
    x1: 41.483,
    x2: 34.47,
    y1: 41.504,
    y2: 34.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38.021,
    r: 5,
    fill: "url(#wOQouxenu~XFRQP1lFFAyi)"
  })), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wOQouxenu~XFRQP1lFFAyj",
    x1: 35.193,
    x2: 40.117,
    y1: 35.214,
    y2: 40.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d61a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#0e5fa4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#135796"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16528c"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38.021,
    r: 3,
    fill: "url(#wOQouxenu~XFRQP1lFFAyj)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8DatabaseAdmin);
export default __webpack_public_path__ + "static/media/icons8-database-admin.3d532bdae4913188d899d556c72f0943.svg";
export { ForwardRef as ReactComponent };